export const brokerError=e=>{
  const detail=e.response?.data?.detail;
  if(typeof detail==='string')return detail;
  if(Array.isArray(detail))return detail.map(row=>row.msg.replace(/^Value error, /,'')).join(' · ');
  return 'İşlem doğrulanamadı. Kayıt listesini kontrol edip yeniden deneyin.';
};
export const destinationLabel=row=>row.kind==='bank'?row.bank_name:`${row.currency} · ${row.network}`;